export enum ObsessedEngineeringEmailSubscription {
    ComponentShipment = 'ComponentShipment',
}
